import type { ChartPoint } from '../../../lib/metrics';
import { formatDateTime, formatDuration } from '../../../lib/time';

interface ChartTooltipProps {
  point: ChartPoint;
  /** x position of the point inside the chart. */
  left: number;
  width: number;
  binMs: number;
  showRange: boolean;
  formatValue: (value: number) => string;
}

/** Hover readout for one chart position: value first, then time and spread. */
export function ChartTooltip({ point, left, width, binMs, showRange, formatValue }: ChartTooltipProps) {
  const flip = left > width - 200;
  return (
    <div
      role="status"
      className="pointer-events-none absolute top-2 z-[2] min-w-[150px] rounded-md bg-surface px-2.5 py-2 shadow-popover"
      style={flip ? { right: width - left + 12 } : { left: left + 12 }}
    >
      <div className="text-xs text-fg-secondary">
        {formatDateTime(point.t)}
        {showRange && <span> · {formatDuration(binMs)} avg</span>}
      </div>
      <div className="mt-0.5 flex items-center gap-2 font-mono text-[15px] font-medium">
        <span className="h-0.5 w-3 rounded-[1px] bg-series-1" aria-hidden />
        {formatValue(point.avg)}
      </div>
      {showRange && (
        <div className="mt-0.5 font-mono text-xs text-fg-muted">
          min {formatValue(point.min)} · max {formatValue(point.max)} · {point.polls} polls
        </div>
      )}
    </div>
  );
}
